import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-HISTORY-SOUSCRIPTIONS-------------------------------------------------*/
export const getHistorySouscriptionsAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORY_SOUSCRIPTIONS,
    payload,
  };
};

export const getHistorySouscriptionsSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORY_SOUSCRIPTIONS_SUCCESS,
    payload,
  };
};

export const getHistorySouscriptionsFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_HISTORY_SOUSCRIPTIONS_FAIL,
    payload,
  };
};
